import { FileUpload } from '../models/file-upload';
import { Logger } from '../models/logger';

export class ConvertOptionsUtils {

    public static TIME_VALIDATE_FN = (value: string, type: string): string => {
        if (type === 'seconds') {
            if (!value.match(/^\d+(\.\d{1,3}){0,1}$/)) {
                return `Accepted value examples i.e 23 (for 23 seconds) \
            or 23.453 for (23 seconds and 453 milliseconds)`;
            }
        }
        if (type === 'formated_time') {
            if (!value.match(/^(\d{1,2}:){0,2}(\d{1,2})(\.\d{1,3}){0,1}$/)) {
                return `Accepted value examples i.e 23 (for 23 seconds) \
            or 23.453 for (23 seconds and 453 milliseconds)
            or 12:23.453 for (12 minutes 23 seconds and 453 milliseconds)
            or 3:1:23.453 for (3 hours 1 minute 23 seconds and 453 milliseconds)`;
            }
        }
        return null;
    };

    public static OUTPUT_EXT_FROM_OPTIONS_FN = (allOptions: any) => {
        if (allOptions.formCategories) {
            const outputExtensionOptions = allOptions.formCategories
                .find(f => f.category === 'outputExt');
            const outputExtensionOption = outputExtensionOptions && outputExtensionOptions.formGroups[0];
            return outputExtensionOption ? outputExtensionOption.selections.find(a => a.selected).formValue : null;
        }
        return null;
    };


    public static hasProperty(fileUpload: FileUpload, property: string) {
        try {
            return !!fileUpload.options.find(i => i.formName === property);
        } catch (e) {
            Logger.getLogger('ConvertOptionsUtils').trace7(`Could not find ${property} on FileUpload options`);
        }
    }

    public static getPropertyValue(fileUpload: FileUpload, property: string) {
        try {
            return fileUpload.options.find(i => i.formName === property).formValue;
        } catch (e) {
            Logger.getLogger('ConvertOptionsUtils').trace7(`Could not find ${property} on FileUpload options`);
        }
    }

    public static getSubPropertyValue(subpropertyValue: any, property: string) {
        try {
            return subpropertyValue.find(i => i.formName === property).formValue;
        } catch (e) {
            Logger.getLogger('ConvertOptionsUtils').trace7(`Could not find property, ${property} on subproperty value`);
        }
    }

    public static hasPropertyWithValue(fileUpload: FileUpload, property: string, value: string) {
        try {
            const object = fileUpload.options.find(i => i.formName === property);
            return object.formValue === value;
        } catch (e) {
            Logger.getLogger('ConvertOptionsUtils').trace7(`Could not find ${property} on FileUpload options`);
        }
    }
}
